export default "__VITE_ASSET__904f36d4__"